export const typologies =
  /* 1 */
  [
    {
      retailer_label: ["U", "INTERMARCHE"],
      id: 1,
      label_fr: "HM",
      label_en: null,
      retailer_id: null,

      __v: 0
    },
    {
      retailer_label: ["U", "INTERMARCHE"],
      id: 2,
      label_fr: "SM",
      label_en: null,
      retailer_id: null,

      __v: 0
    },
    {
      retailer_label: ["INTERMARCHE"],
      id: 3,
      label_fr: "CONTACT",
      label_en: null,
      retailer_id: null,

      __v: 0
    },
    {
      retailer_label: ["U", "INTERMARCHE"],
      id: 4,
      label_fr: "EXPRESS",
      label_en: null,
      retailer_id: null,

      __v: 0
    },
    {
      retailer_label: ["U"],
      id: 5,
      label_fr: "UTILE",
      label_en: null,
      retailer_id: null,

      __v: 0
    },
    {
      retailer_label: ["FRANPRIX"],
      id: 6,
      label_fr: "PROXI",
      label_en: null,
      retailer_id: null,

      __v: 0
    },
    {
      retailer_label: ["LECLERC"],
      id: 7,
      label_fr: "DRIVE",
      label_en: null,
      retailer_id: null,

      __v: 0
    },
    {
      retailer_label: ["PHARMACIE"],
      id: 8,
      label_fr: "BRONZE",
      label_en: null,
      retailer_id: "R347",

      __v: 0
    },
    {
      retailer_label: ["PHARMACIE"],
      id: 9,
      label_fr: "CROISSANCE",
      label_en: null,
      retailer_id: "R347",

      __v: 0
    },
    {
      retailer_label: ["PHARMACIE"],
      id: 10,
      label_fr: "GR1",
      label_en: null,
      retailer_id: "R347",

      __v: 0
    },
    {
      retailer_label: ["PHARMACIE"],
      id: 11,
      label_fr: "PARTENAIRE",
      label_en: null,
      retailer_id: "R347",

      __v: 0
    },
    {
      retailer_label: ["PHARMACIE"],
      id: 12,
      label_fr: "PHARMABEST",
      label_en: null,
      retailer_id: "R347",

      __v: 0
    },
    {
      retailer_label: ["PHARMACIE"],
      id: 13,
      label_fr: "NON VISITES (HORS CLUBS)",
      label_en: null,
      retailer_id: "R347",

      __v: 0
    },
    {
      retailer_label: ["PHARMACIE"],
      id: 14,
      label_fr: "ENGAGEMENT",
      label_en: null,
      retailer_id: "R347",

      __v: 0
    },
    {
      retailer_label: null,
      id: 900,
      label_fr: "GSS",
      label_en: null,
      retailer_id: null
    },
    {
      retailer_label: null,
      id: 901,
      label_fr: "GSB",
      label_en: null,
      retailer_id: null
    }
  ];
export const retailers = [
  {
    label: "1000 FRAIS",
    id: "R1"
  },
  {
    label: "7J",
    id: "R2"
  },
  {
    label: "8 A HUIT",
    id: "R3"
  },
  {
    label: "A A Z",
    id: "R4"
  },
  {
    label: "A COTE",
    id: "R5"
  },
  {
    label: "A2PAS",
    id: "R6"
  },
  {
    label: "ABAKKAS LAHCEN",
    id: "R7"
  },
  {
    label: "ABEILLE",
    id: "R8"
  },
  {
    label: "ACCASTILLAGE DIFFUSION",
    id: "R9"
  },
  {
    label: "AELIA",
    id: "R10"
  },
  {
    label: "AGIP",
    id: "R11"
  },
  {
    label: "AGRIAL",
    id: "R12"
  },
  {
    label: "AIXAM",
    id: "R13"
  },
  {
    label: "ALDI",
    id: "R14"
  },
  {
    label: "ALIMA",
    id: "R15"
  },
  {
    label: "ALIMENTATION DRAPEAU",
    id: "R16"
  },
  {
    label: "ALIMENTATION DU GOLFE",
    id: "R17"
  },
  {
    label: "ALIMENTATION DU PORT",
    id: "R18"
  },
  {
    label: "ALIMENTATION EPICERIE",
    id: "R19"
  },
  {
    label: "ALIMENTATION GENERALE",
    id: "R20"
  },
  {
    label: "ALIMENTATION LA FINHANAISE",
    id: "R21"
  },
  {
    label: "ALINEA",
    id: "R22"
  },
  {
    label: "AMATOR",
    id: "R23"
  },
  {
    label: "AMOURI SERVICE",
    id: "R24"
  },
  {
    label: "API CAFET",
    id: "R25"
  },
  {
    label: "API SELF",
    id: "R26"
  },
  {
    label: "ARARAT",
    id: "R27"
  },
  {
    label: "AS MARCHE SUPERMARCHE",
    id: "R28"
  },
  {
    label: "AS24",
    id: "R29"
  },
  {
    label: "ATAC",
    id: "R30"
  },
  {
    label: "ATAC DISCOUNT",
    id: "R31"
  },
  {
    label: "ATLAS",
    id: "R32"
  },
  {
    label: "AU BON MARCHE",
    id: "R33"
  },
  {
    label: "AU BON PRODUIT",
    id: "R34"
  },
  {
    label: "AU COUCOU GOURMAND",
    id: "R35"
  },
  {
    label: "AU JARDIN D'ESPAGNE",
    id: "R36"
  },
  {
    label: "AU PETIT MARCHE",
    id: "R37"
  },
  {
    label: "AU PETIT MARCHE 4 SAISONS",
    id: "R38"
  },
  {
    label: "AU POTAGER DE BELLEVILLE",
    id: "R39"
  },
  {
    label: "AUBRUN",
    id: "R40"
  },
  {
    label: "AUCHAN",
    id: "R41"
  },
  {
    label: "AUCHAN CITY",
    id: "R42"
  },
  {
    label: "AUCHAN SUPERMARCHE",
    id: "R43"
  },
  {
    label: "AUTODISTRIBUTION",
    id: "R44"
  },
  {
    label: "AUTRE GSA",
    id: "R45"
  },
  {
    label: "AUTRE GSB",
    id: "R46"
  },
  {
    label: "AUTRE GSS",
    id: "R47"
  },
  {
    label: "AUTRE IMPULSE",
    id: "R48"
  },
  {
    label: "AUX DEUX SAISONS",
    id: "R49"
  },
  {
    label: "AUX GALERIES",
    id: "R50"
  },
  {
    label: "AVIA",
    id: "R51"
  },
  {
    label: "BABOU",
    id: "R52"
  },
  {
    label: "BANCO",
    id: "R53"
  },
  {
    label: "BARTHELEMY CASH",
    id: "R54"
  },
  {
    label: "BATI LOISIRS",
    id: "R55"
  },
  {
    label: "BATKOR",
    id: "R56"
  },
  {
    label: "BBG",
    id: "R57"
  },
  {
    label: "BEBE FOURMI",
    id: "R58"
  },
  {
    label: "BERNARD PHILIBERT",
    id: "R59"
  },
  {
    label: "BHV",
    id: "R60"
  },
  {
    label: "BI1",
    id: "R61"
  },
  {
    label: "BIG MAT",
    id: "R62"
  },
  {
    label: "BIO C'BON",
    id: "R63"
  },
  {
    label: "BIOCOOP",
    id: "R64"
  },
  {
    label: "BLANCHARD",
    id: "R65"
  },
  {
    label: "BOTANIC",
    id: "R66"
  },
  {
    label: "BOTICINAL",
    id: "R67"
  },
  {
    label: "BOULANGER",
    id: "R68"
  },
  {
    label: "BOULANGERIE",
    id: "R69"
  },
  {
    label: "BOUSSETON",
    id: "R70"
  },
  {
    label: "BP",
    id: "R71"
  },
  {
    label: "BRAVO",
    id: "R72"
  },
  {
    label: "BRICK",
    id: "R73"
  },
  {
    label: "BRICO",
    id: "R74"
  },
  {
    label: "BRICO CASH",
    id: "R75"
  },
  {
    label: "BRICO DECO",
    id: "R76"
  },
  {
    label: "BRICO DEPOT",
    id: "R77"
  },
  {
    label: "BRICO E.LECLERC",
    id: "R78"
  },
  {
    label: "BRICO PRO",
    id: "R79"
  },
  {
    label: "BRICOMAN",
    id: "R80"
  },
  {
    label: "BRICOMARCHE",
    id: "R81"
  },
  {
    label: "BRICOR",
    id: "R82"
  },
  {
    label: "BRICORAMA",
    id: "R83"
  },
  {
    label: "BUREAU VALLEE",
    id: "R84"
  },
  {
    label: "BUT",
    id: "R85"
  },
  {
    label: "BUT COSY",
    id: "R86"
  },
  {
    label: "C EXPRESS",
    id: "R87"
  },
  {
    label: "CALI",
    id: "R88"
  },
  {
    label: "CAMPUS",
    id: "R89"
  },
  {
    label: "CAP BRICOLAGE",
    id: "R90"
  },
  {
    label: "CARREFOUR",
    id: "R91"
  },
  {
    label: "CARREFOUR BIO",
    id: "R92"
  },
  {
    label: "Carrefour Bon App",
    id: "R93"
  },
  {
    label: "CARREFOUR CITY",
    id: "R94"
  },
  {
    label: "CARREFOUR CONTACT",
    id: "R95"
  },
  {
    label: "CARREFOUR EXPRESS",
    id: "R96"
  },
  {
    label: "CARREFOUR MARKET",
    id: "R97"
  },
  {
    label: "CARREFOUR MONTAGNE",
    id: "R98"
  },
  {
    label: "CARREFOUR ONE",
    id: "R99"
  },
  {
    label: "CARREFOUR PLANET",
    id: "R100"
  },
  {
    label: "CASH ALIMENTAIRE SUD EST",
    id: "R101"
  },
  {
    label: "CASH BENECH",
    id: "R102"
  },
  {
    label: "CASH CASIBEL",
    id: "R103"
  },
  {
    label: "CASH CORSES",
    id: "R104"
  },
  {
    label: "CASH MONTEL",
    id: "R105"
  },
  {
    label: "CASINO",
    id: "R106"
  },
  {
    label: "CASINO DISCOUNT",
    id: "R107"
  },
  {
    label: "CASINO SHOP",
    id: "R108"
  },
  {
    label: "CASINO SHOPPING",
    id: "R109"
  },
  {
    label: "CASITALIA",
    id: "R110"
  },
  {
    label: "CASTORAMA",
    id: "R111"
  },
  {
    label: "CATENA",
    id: "R112"
  },
  {
    label: "CEIDO",
    id: "R113"
  },
  {
    label: "CENTRE DISTRIBUTEUR ALPIN",
    id: "R114"
  },
  {
    label: "CGS MARINE",
    id: "R115"
  },
  {
    label: "CHAMPION",
    id: "R116"
  },
  {
    label: "CHEZ L'EPICIER MAGDUNOIS",
    id: "R117"
  },
  {
    label: "CITYPHARMA",
    id: "R118"
  },
  {
    label: "COCCICASH",
    id: "R119"
  },
  {
    label: "COCCIMARKET",
    id: "R120"
  },
  {
    label: "COCCINELLE",
    id: "R121"
  },
  {
    label: "COCCINELLE EXPRESS",
    id: "R122"
  },
  {
    label: "CODEC",
    id: "R123"
  },
  {
    label: "CODI CASH",
    id: "R124"
  },
  {
    label: "COLRUYT",
    id: "R125"
  },
  {
    label: "COMPASS - EUREST",
    id: "R126"
  },
  {
    label: "COMPASS EUREST CAFET",
    id: "R127"
  },
  {
    label: "COMPASS EUREST SELF",
    id: "R128"
  },
  {
    label: "CONFORAMA",
    id: "R129"
  },
  {
    label: "CONNEXION",
    id: "R130"
  },
  {
    label: "CONTACT MARCHE",
    id: "R131"
  },
  {
    label: "COOK SHOP",
    id: "R132"
  },
  {
    label: "COOP",
    id: "R133"
  },
  {
    label: "COOPERATIVE OBJECTIF SANTE",
    id: "R134"
  },
  {
    label: "CORA",
    id: "R135"
  },
  {
    label: "CORSAIRE",
    id: "R136"
  },
  {
    label: "COTÉ BOULANGERIE",
    id: "R137"
  },
  {
    label: "CRETEIL STORE",
    id: "R138"
  },
  {
    label: "DARTY",
    id: "R139"
  },
  {
    label: "DARTY PF",
    id: "R140"
  },
  {
    label: "DEROCHE",
    id: "R141"
  },
  {
    label: "DESCOURS CABAUD",
    id: "R142"
  },
  {
    label: "DIA",
    id: "R143"
  },
  {
    label: "DIAGONAL",
    id: "R144"
  },
  {
    label: "DIGITAL ADHERENT",
    id: "R145"
  },
  {
    label: "DIGITAL PLATEFORMES",
    id: "R146"
  },
  {
    label: "DISMARCHE",
    id: "R147"
  },
  {
    label: "DISTRIFOOD",
    id: "R148"
  },
  {
    label: "DOUMAL BRAHIM",
    id: "R149"
  },
  {
    label: "DUNDAR SERIFE ALIMENTATION",
    id: "R150"
  },
  {
    label: "DYNEFF",
    id: "R151"
  },
  {
    label: "EASY MARCHE",
    id: "R152"
  },
  {
    label: "EASYFIT",
    id: "R153"
  },
  {
    label: "ECO FRAIS",
    id: "R154"
  },
  {
    label: "ECO SERVICE",
    id: "R155"
  },
  {
    label: "ECOMARCHE",
    id: "R156"
  },
  {
    label: "ED",
    id: "R157"
  },
  {
    label: "EK SERVICE GROUP",
    id: "R158"
  },
  {
    label: "ELAN",
    id: "R159"
  },
  {
    label: "ELECTRO DEPOT",
    id: "R160"
  },
  {
    label: "ELF",
    id: "R161"
  },
  {
    label: "ELIOR",
    id: "R162"
  },
  {
    label: "ELIOR CAFET",
    id: "R163"
  },
  {
    label: "ELIOR SELF",
    id: "R164"
  },
  {
    label: "ELSIE",
    id: "R165"
  },
  {
    label: "EPI",
    id: "R166"
  },
  {
    label: "EPI EPICERIE",
    id: "R167"
  },
  {
    label: "EPI SERVICE",
    id: "R168"
  },
  {
    label: "EPICERIE MONDULFINE",
    id: "R169"
  },
  {
    label: "EPICERIE TROIS ETOILES",
    id: "R170"
  },
  {
    label: "ESPACE EMERAUDE",
    id: "R171"
  },
  {
    label: "ESSO",
    id: "R172"
  },
  {
    label: "ETS BECKER",
    id: "R173"
  },
  {
    label: "ETS GOSSELIN",
    id: "R174"
  },
  {
    label: "EUROCASH",
    id: "R175"
  },
  {
    label: "EURONICS",
    id: "R176"
  },
  {
    label: "EUROPRIX",
    id: "R177"
  },
  {
    label: "EUROSALAM",
    id: "R178"
  },
  {
    label: "EXO IMPEX",
    id: "R179"
  },
  {
    label: "EXO STORE",
    id: "R180"
  },
  {
    label: "EXPERT",
    id: "R181"
  },
  {
    label: "EXPRESS",
    id: "R182"
  },
  {
    label: "FAMILIPRIX",
    id: "R183"
  },
  {
    label: "FLUNCH",
    id: "R184"
  },
  {
    label: "FLY",
    id: "R185"
  },
  {
    label: "FNAC",
    id: "R186"
  },
  {
    label: "FOOD ALPES ETOILE SUPER",
    id: "R187"
  },
  {
    label: "FOOD TRUCK",
    id: "R188"
  },
  {
    label: "FORUM SANTE",
    id: "R189"
  },
  {
    label: "FRANPRIX",
    id: "R190"
  },
  {
    label: "FRANPRIX LE MARCHE GOURMAND",
    id: "R191"
  },
  {
    label: "FRANPRIX NANO",
    id: "R192"
  },
  {
    label: "FREDI",
    id: "R193"
  },
  {
    label: "G20",
    id: "R194"
  },
  {
    label: "GALERIES GOURMANDES",
    id: "R195"
  },
  {
    label: "GALERIES LAFAYETTE",
    id: "R196"
  },
  {
    label: "GALERIES MODERNES",
    id: "R197"
  },
  {
    label: "GAM",
    id: "R198"
  },
  {
    label: "GAMM VERT",
    id: "R199"
  },
  {
    label: "GAMM VERT NATURE",
    id: "R200"
  },
  {
    label: "GAMM VERT VILLAGE",
    id: "R201"
  },
  {
    label: "GARAGE INDÉPENDANT",
    id: "R202"
  },
  {
    label: "GEANT CASINO",
    id: "R203"
  },
  {
    label: "GEANT DISCOUNT",
    id: "R204"
  },
  {
    label: "GEDIMAT",
    id: "R205"
  },
  {
    label: "GERFRA",
    id: "R206"
  },
  {
    label: "GIFI",
    id: "R207"
  },
  {
    label: "Giphar",
    id: "R208"
  },
  {
    label: "GITEM",
    id: "R209"
  },
  {
    label: "GLOBE",
    id: "R210"
  },
  {
    label: "GO SPORT",
    id: "R211"
  },
  {
    label: "GPO",
    id: "R212"
  },
  {
    label: "GRAND FRAIS",
    id: "R213"
  },
  {
    label: "GRANDE EPICERIE DE PARIS",
    id: "R214"
  },
  {
    label: "GSS INDEP",
    id: "R215"
  },
  {
    label: "HALLES FRANCS BOURGEOIS",
    id: "R216"
  },
  {
    label: "INSTITUT",
    id: "R217"
  },
  {
    label: "HYPER CASINO",
    id: "R218"
  },
  {
    label: "HYPER V",
    id: "R219"
  },
  {
    label: "HYPERCACHER",
    id: "R220"
  },
  {
    label: "IKEA",
    id: "R221"
  },
  {
    label: "Impulse",
    id: "R222"
  },
  {
    label: "indoor garden",
    id: "R223"
  },
  {
    label: "INNO",
    id: "R224"
  },
  {
    label: "INNOCASH",
    id: "R225"
  },
  {
    label: "INTERMARCHE",
    id: "R226"
  },
  {
    label: "INTERSPORT",
    id: "R227"
  },
  {
    label: "JARDILAND",
    id: "R228"
  },
  {
    label: "JARDINE GUY",
    id: "R229"
  },
  {
    label: "JARDINS DES DOUCETS",
    id: "R230"
  },
  {
    label: "JEANTEUR",
    id: "R231"
  },
  {
    label: "KASSIS",
    id: "R232"
  },
  {
    label: "KEBAB",
    id: "R233"
  },
  {
    label: "L ENTREPOT DU BRICOLAGE",
    id: "R234"
  },
  {
    label: "LA BOITE A OUTILS",
    id: "R235"
  },
  {
    label: "LA CROIX DOREE",
    id: "R236"
  },
  {
    label: "LA DRAMONTOISE",
    id: "R237"
  },
  {
    label: "LA FERME DU SAPHI",
    id: "R238"
  },
  {
    label: "LA HALLE DE L'ARTISAN",
    id: "R239"
  },
  {
    label: "LA LIDONNAISE",
    id: "R240"
  },
  {
    label: "LA MAISON POINT VERT",
    id: "R241"
  },
  {
    label: "LA PLATEFORME DU BATIMENT",
    id: "R242"
  },
  {
    label: "LA SUPERETTE",
    id: "R243"
  },
  {
    label: "LA SUPERETTE D'EUGENIE",
    id: "R244"
  },
  {
    label: "LA SUPERETTE DU QUESNE",
    id: "R245"
  },
  {
    label: "LA TARTE TROPÉZIENNE",
    id: "R246"
  },
  {
    label: "LA VIE CLAIRE",
    id: "R247"
  },
  {
    label: "LABONNE",
    id: "R248"
  },
  {
    label: "LAFAYETTE GOURMET",
    id: "R249"
  },
  {
    label: "LE DOUX ANNE-MARIE",
    id: "R250"
  },
  {
    label: "LE MARCHE",
    id: "R251"
  },
  {
    label: "LE MARCHE D'A COTE",
    id: "R252"
  },
  {
    label: "LE MARCHE DE SAVOIE",
    id: "R253"
  },
  {
    label: "LE MARCHE DES FORGES",
    id: "R254"
  },
  {
    label: "LE MARCHE DES QUINTUS",
    id: "R255"
  },
  {
    label: "LE MARCHE VIVECO",
    id: "R256"
  },
  {
    label: "LE MUTANT",
    id: "R257"
  },
  {
    label: "Le Petit Casino",
    id: "R258"
  },
  {
    label: "LE PETIT MARCHE",
    id: "R259"
  },
  {
    label: "LEADER EXPRESS",
    id: "R260"
  },
  {
    label: "LEADER PRICE",
    id: "R261"
  },
  {
    label: "LEADER SANTE",
    id: "R262"
  },
  {
    label: "LECLERC",
    id: "R263"
  },
  {
    label: "LECLERC CULTURE",
    id: "R264"
  },
  {
    label: "LECLERC DRIVE",
    id: "R265"
  },
  {
    label: "LECLERC EXPRESS",
    id: "R266"
  },
  {
    label: "LECLERC TECHNIC ET MAISON",
    id: "R267"
  },
  {
    label: "LEGALL Santé Services",
    id: "R268"
  },
  {
    label: "L'EPICIER GASCON",
    id: "R269"
  },
  {
    label: "LEROY MERLIN",
    id: "R270"
  },
  {
    label: "LES BRICONAUTES",
    id: "R271"
  },
  {
    label: "LES GALERIES",
    id: "R272"
  },
  {
    label: "LES HALLES CORSES",
    id: "R273"
  },
  {
    label: "LES HALLES D'AUCHAN",
    id: "R274"
  },
  {
    label: "LES HALLES DE QUERCAMPS",
    id: "R275"
  },
  {
    label: "LES NOUVEAUX ROBINSON",
    id: "R276"
  },
  {
    label: "LES PRIMEURS DU BOURG",
    id: "R277"
  },
  {
    label: "LES SAVEURS DU MAIL",
    id: "R278"
  },
  {
    label: "LIBRE SERVICE",
    id: "R279"
  },
  {
    label: "LIBRE SERVICE ALIMENTAIRE",
    id: "R280"
  },
  {
    label: "LIBRE SERVICE CACOPARDO",
    id: "R281"
  },
  {
    label: "LIBRE SERVICE SAINT ANTOIN",
    id: "R282"
  },
  {
    label: "LIDL",
    id: "R283"
  },
  {
    label: "LINGERIE",
    id: "R284"
  },
  {
    label: "LOU MERCAT",
    id: "R285"
  },
  {
    label: "LUMILAND",
    id: "R286"
  },
  {
    label: "L'UNION",
    id: "R287"
  },
  {
    label: "MAGASIN L",
    id: "R288"
  },
  {
    label: "MAISADOUR",
    id: "R289"
  },
  {
    label: "MAISON DU MONDE",
    id: "R290"
  },
  {
    label: "MAISON REIGNIER",
    id: "R291"
  },
  {
    label: "MARCHE DES ROSIERS",
    id: "R292"
  },
  {
    label: "MARCHE GB",
    id: "R293"
  },
  {
    label: "MARCHE PLUS",
    id: "R294"
  },
  {
    label: "MARCHE PRESQU'ILE",
    id: "R295"
  },
  {
    label: "MARCHE U",
    id: "R296"
  },
  {
    label: "MARKS AND SPENCER",
    id: "R297"
  },
  {
    label: "MATCH",
    id: "R298"
  },
  {
    label: "MAXI",
    id: "R299"
  },
  {
    label: "MAXI SERVICE",
    id: "R300"
  },
  {
    label: "MAXICOOP",
    id: "R301"
  },
  {
    label: "MAXIMARCHE",
    id: "R302"
  },
  {
    label: "MDA",
    id: "R303"
  },
  {
    label: "MEDIPRIX",
    id: "R304"
  },
  {
    label: "METRO",
    id: "R305"
  },
  {
    label: "METRO DRIVE",
    id: "R306"
  },
  {
    label: "MIDIPRIX",
    id: "R307"
  },
  {
    label: "MIGROS",
    id: "R308"
  },
  {
    label: "MINI MARCHE DE LA PEPINIER",
    id: "R309"
  },
  {
    label: "MIRAN LIBRE SERVICE",
    id: "R310"
  },
  {
    label: "MIRANDA",
    id: "R311"
  },
  {
    label: "MONOP",
    id: "R312"
  },
  {
    label: "MONOP DAILY",
    id: "R313"
  },
  {
    label: "MONOP STATION",
    id: "R314"
  },
  {
    label: "MONOP STORE",
    id: "R315"
  },
  {
    label: "MONOPRIX",
    id: "R316"
  },
  {
    label: "MONOPRIX MODE",
    id: "R317"
  },
  {
    label: "MONOPRIX NGAL",
    id: "R318"
  },
  {
    label: "MPI",
    id: "R319"
  },
  {
    label: "MR BRICOLAGE",
    id: "R320"
  },
  {
    label: "MUTANT EXPRESS",
    id: "R321"
  },
  {
    label: "NATURALIA",
    id: "R322"
  },
  {
    label: "NETTO",
    id: "R323"
  },
  {
    label: "NORAUTO",
    id: "R324"
  },
  {
    label: "NORMANDIE ALIMENTAIRE",
    id: "R325"
  },
  {
    label: "NOUVEAU SUPERMARCHE WENZHO",
    id: "R326"
  },
  {
    label: "NOUVELLES GALERIES",
    id: "R327"
  },
  {
    label: "OFFICE DEPOT",
    id: "R328"
  },
  {
    label: "OFFINCO",
    id: "R329"
  },
  {
    label: "OIL FRANCE",
    id: "R330"
  },
  {
    label: "PANIER GOURMAND",
    id: "R331"
  },
  {
    label: "PANIER SYMPA",
    id: "R332"
  },
  {
    label: "PANIER SYMPA SANAC",
    id: "R333"
  },
  {
    label: "PARA AUCHAN",
    id: "R334"
  },
  {
    label: "PARA CARREFOUR",
    id: "R335"
  },
  {
    label: "PARA LECLERC",
    id: "R336"
  },
  {
    label: "PARA MONOPRIX",
    id: "R337"
  },
  {
    label: "PARACITY EIFFEL",
    id: "R338"
  },
  {
    label: "PARAPHARMACIE",
    id: "R339"
  },
  {
    label: "PARIS STORE",
    id: "R340"
  },
  {
    label: "PARIS TIZNIT",
    id: "R341"
  },
  {
    label: "PARISPHARMA",
    id: "R342"
  },
  {
    label: "Parquet - Indépendants",
    id: "R343"
  },
  {
    label: "PARFUMERIE",
    id: "R344"
  },
  {
    label: "PETIT CASINO",
    id: "R345"
  },
  {
    label: "PETROLIER INDEPENDANT",
    id: "R346"
  },
  {
    label: "PHARMACIE",
    id: "R347"
  },
  {
    label: "PHARMABEST",
    id: "R348"
  },
  {
    label: "PHARMACIE LAFAYETTE",
    id: "R349"
  },
  {
    label: "Pharmacie Mutualiste",
    id: "R350"
  },
  {
    label: "PHARMAFORCE",
    id: "R351"
  },
  {
    label: "PHARMAVANCE",
    id: "R352"
  },
  {
    label: "PHARMAVIE",
    id: "R353"
  },
  {
    label: "POINT",
    id: "R354"
  },
  {
    label: "POINT COOP",
    id: "R355"
  },
  {
    label: "POINT P",
    id: "R356"
  },
  {
    label: "POINT P TP",
    id: "R357"
  },
  {
    label: "POINT VERT",
    id: "R358"
  },
  {
    label: "PRIBA AUCHAN",
    id: "R359"
  },
  {
    label: "PRIMELAND",
    id: "R360"
  },
  {
    label: "PRINTEMPS",
    id: "R361"
  },
  {
    label: "PRO AND CIE",
    id: "R362"
  },
  {
    label: "PROMAG",
    id: "R363"
  },
  {
    label: "PROMOCASH",
    id: "R364"
  },
  {
    label: "PROMOCASH DRIVE",
    id: "R365"
  },
  {
    label: "Prospection",
    id: "R366"
  },
  {
    label: "PROXI",
    id: "R367"
  },
  {
    label: "PROXI SERVICE",
    id: "R368"
  },
  {
    label: "PROXI SUPER",
    id: "R369"
  },
  {
    label: "PROXIMARCHE",
    id: "R370"
  },
  {
    label: "PULSAT",
    id: "R371"
  },
  {
    label: "QUICK",
    id: "R372"
  },
  {
    label: "RAPID MARKET",
    id: "R373"
  },
  {
    label: "RAVIERES DISTRIBUTION",
    id: "R374"
  },
  {
    label: "RCI CAFET",
    id: "R375"
  },
  {
    label: "RCI SELF",
    id: "R376"
  },
  {
    label: "RECAPE",
    id: "R377"
  },
  {
    label: "RECORD",
    id: "R378"
  },
  {
    label: "RELAIS DES MOUSQUETAIRES",
    id: "R379"
  },
  {
    label: "REXEL",
    id: "R380"
  },
  {
    label: "RIBEMONT SERVICE",
    id: "R381"
  },
  {
    label: "SAADOUN DAVID",
    id: "R382"
  },
  {
    label: "SALAM",
    id: "R383"
  },
  {
    label: "SAMSE",
    id: "R384"
  },
  {
    label: "SCHIEVER",
    id: "R385"
  },
  {
    label: "SCHLECKER",
    id: "R386"
  },
  {
    label: "SCORE",
    id: "R387"
  },
  {
    label: "SDA",
    id: "R388"
  },
  {
    label: "SELECTIS",
    id: "R389"
  },
  {
    label: "SHELL",
    id: "R390"
  },
  {
    label: "SHERPA",
    id: "R391"
  },
  {
    label: "SHOPI",
    id: "R392"
  },
  {
    label: "SIMPLY GALERIES GOURMANDES",
    id: "R393"
  },
  {
    label: "SIMPLY MARKET",
    id: "R394"
  },
  {
    label: "SIMPLY MARKET GOURMAND",
    id: "R395"
  },
  {
    label: "SITIS",
    id: "R396"
  },
  {
    label: "SOCIETE PARISTORE",
    id: "R397"
  },
  {
    label: "SOCIETE SONAH",
    id: "R398"
  },
  {
    label: "SODEXO",
    id: "R399"
  },
  {
    label: "SODEXO CAFET",
    id: "R400"
  },
  {
    label: "SODEXO SELF",
    id: "R401"
  },
  {
    label: "SONODIAL",
    id: "R402"
  },
  {
    label: "SPAR",
    id: "R403"
  },
  {
    label: "SPAR ATOUT HEURE",
    id: "R404"
  },
  {
    label: "SPAR MARCHE",
    id: "R405"
  },
  {
    label: "SPAR MONTAGNE",
    id: "R406"
  },
  {
    label: "SPAR SERVICE",
    id: "R407"
  },
  {
    label: "SPAR SUPERMARCHE",
    id: "R408"
  },
  {
    label: "STATION Q8",
    id: "R409"
  },
  {
    label: "STE MERMOZ",
    id: "R410"
  },
  {
    label: "STOKOMANI",
    id: "R411"
  },
  {
    label: "STRASBOURG DISTRIBUTION PA",
    id: "R412"
  },
  {
    label: "SUERETTR ATOUTS DISTRIB",
    id: "R413"
  },
  {
    label: "SUP ALAN",
    id: "R414"
  },
  {
    label: "SUPER CATENA",
    id: "R415"
  },
  {
    label: "SUPER CHAMPRIX",
    id: "R416"
  },
  {
    label: "SUPER MONOPRIX",
    id: "R417"
  },
  {
    label: "SUPER TONI",
    id: "R418"
  },
  {
    label: "SUPERETTE",
    id: "R419"
  },
  {
    label: "SUPERETTE ALGEPA",
    id: "R420"
  },
  {
    label: "SUPERETTE BALAGNY",
    id: "R421"
  },
  {
    label: "SUPERETTE BEAUMARCHAIS",
    id: "R422"
  },
  {
    label: "SUPERETTE BEAUMONT",
    id: "R423"
  },
  {
    label: "SUPERETTE BEL AIR",
    id: "R424"
  },
  {
    label: "SUPERETTE DE LA MARINE",
    id: "R425"
  },
  {
    label: "SUPERETTE DE L'ABBAYE",
    id: "R426"
  },
  {
    label: "SUPERETTE DE L'EGLISE",
    id: "R427"
  },
  {
    label: "SUPERETTE DE TERGNIER",
    id: "R428"
  },
  {
    label: "SUPERETTE DU LAC",
    id: "R429"
  },
  {
    label: "SUPERETTE DU LEVANT",
    id: "R430"
  },
  {
    label: "SUPERETTE DU MARAIS",
    id: "R431"
  },
  {
    label: "SUPERETTE DU VILLAGE",
    id: "R432"
  },
  {
    label: "SUPERETTE DUVENECH",
    id: "R433"
  },
  {
    label: "SUPERETTE EPICERIE",
    id: "R434"
  },
  {
    label: "SUPERETTE FRANCOIS",
    id: "R435"
  },
  {
    label: "SUPERETTE HIPPERT",
    id: "R436"
  },
  {
    label: "SUPERETTE LE PELICAN",
    id: "R437"
  },
  {
    label: "SUPERETTE PLUS",
    id: "R438"
  },
  {
    label: "SUPERETTE SAINT BONNET",
    id: "R439"
  },
  {
    label: "SUPERETTE SAINT GERMAIN",
    id: "R440"
  },
  {
    label: "SUPERMARCHE",
    id: "R441"
  },
  {
    label: "SUPERMARCHE BAHADOURIAN",
    id: "R442"
  },
  {
    label: "SUPERMARCHE BARON",
    id: "R443"
  },
  {
    label: "SUPERMARCHE BELLONCLE",
    id: "R444"
  },
  {
    label: "SUPERMARCHE DAUPHINOIS",
    id: "R445"
  },
  {
    label: "SUPERMARCHE DES CHAMOIS",
    id: "R446"
  },
  {
    label: "SUPERMARCHE FREUND",
    id: "R447"
  },
  {
    label: "SUPERMARCHE LE CASTELLAS",
    id: "R448"
  },
  {
    label: "SUPERMARCKET",
    id: "R449"
  },
  {
    label: "Synergiphar",
    id: "R450"
  },
  {
    label: "TABAC PRESSE",
    id: "R451"
  },
  {
    label: "TANG FRERES",
    id: "R452"
  },
  {
    label: "TANGUY",
    id: "R453"
  },
  {
    label: "TERRE DU SUD",
    id: "R454"
  },
  {
    label: "TIMY",
    id: "R455"
  },
  {
    label: "TIVA",
    id: "R456"
  },
  {
    label: "TOTAL",
    id: "R457"
  },
  {
    label: "TOTAL ACCESS",
    id: "R458"
  },
  {
    label: "TRIDOME",
    id: "R459"
  },
  {
    label: "TRUFFAUT",
    id: "R460"
  },
  {
    label: "U",
    id: "R461"
  },
  {
    label: "U TECHNOLOGIE",
    id: "R462"
  },
  {
    label: "UBALDI",
    id: "R463"
  },
  {
    label: "UNIVERS PHARMACIE",
    id: "R464"
  },
  {
    label: "USHIP",
    id: "R465"
  },
  {
    label: "VAE",
    id: "R466"
  },
  {
    label: "VAL SERVICE DISTRIBUTION",
    id: "R467"
  },
  {
    label: "VELAN",
    id: "R468"
  },
  {
    label: "VITO",
    id: "R469"
  },
  {
    label: "VIVAL",
    id: "R470"
  },
  {
    label: "VIVECO",
    id: "R471"
  },
  {
    label: "VOTRE MARCHE",
    id: "R472"
  },
  {
    label: "VOTRE MARCHE LITTORAL",
    id: "R473"
  },
  {
    label: "VOTRE MARCHE RELAIS PORT",
    id: "R474"
  },
  {
    label: "W DIFFUSION",
    id: "R475"
  },
  {
    label: "WELDOM",
    id: "R476"
  },
  {
    label: "ZARA",
    id: "R477"
  },
  {
    label: "LDLC",
    id: "R478"
  },
  {
    label: "LA MAISON",
    id: "R479"
  },
  {
    label: "MIDICA",
    id: "R480"
  },
  {
    label: "PROBOX",
    id: "R481"
  },
  {
    label: "BRICOLEX",
    id: "R482"
  },
  {
    label: "BRIQUIN",
    id: "R483"
  },
  {
    label: "LAPEYRE",
    id: "R484"
  },
  {
    label: "MOBALPA",
    id: "R485"
  },
  {
    label: "CUISINE INDEPENDANTS",
    id: "R486"
  },
  {
    label: "CUISINE PLUS",
    id: "R487"
  },
  {
    label: "CUISINELLA",
    id: "R488"
  },
  {
    label: "CUISINES REFERENCES",
    id: "R489"
  },
  {
    label: "FINDIS",
    id: "R490"
  },
  {
    label: "IXINA",
    id: "R491"
  },
  {
    label: "PERENE",
    id: "R492"
  },
  {
    label: "SCHMIDT",
    id: "R493"
  },
  {
    label: "SOCOOC",
    id: "R494"
  },
  {
    label: "TOTAL CONSORTIUM",
    id: "R495"
  },
  {
    label: "PROSPECTION",
    id: "R496"
  },
  {
    label: "CASH N GO",
    id: "R497"
  },
  {
    label: "MIDICA",
    id: "R498"
  },
  {
    label: "AUCHAN SCHIEVER",
    id: "R499"
  }
];



// WEBPACK FOOTER //
// src/pages/basepdc/Constants/temp.constants.js